import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
}

const HometaxNoBmanError = ({ onPrimaryButtonClick }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_document-dimmed_md.svg" width={80} height={80} />,
    title: `양도소득세 신고 내역이 없어\n환급액을 조회할 수 없어요`,
    description: '지난 5년 간 신고 내역 중\n더 낸 세금을 조회해요.',
    primaryButtonText: '확인',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'tonal-secondary'
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default HometaxNoBmanError;
